import React, { useEffect, useRef } from 'react'

// Top scroll-progress bar + soft cursor glow (fine pointers only).
function ScrollEffects() {
  const barRef = useRef(null)
  const glowRef = useRef(null)

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight
      const p = max > 0 ? window.scrollY / max : 0
      if (barRef.current) barRef.current.style.transform = `scaleX(${p})`
    }
    const onMove = e => {
      if (glowRef.current) {
        glowRef.current.style.transform = `translate(${e.clientX - 200}px, ${e.clientY - 200}px)`
      }
    }
    const fine = window.matchMedia('(pointer: fine)').matches
    window.addEventListener('scroll', onScroll, { passive: true })
    if (fine) window.addEventListener('mousemove', onMove)
    onScroll()
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('mousemove', onMove)
    }
  }, [])

  return (
    <>
      <div className="scroll-progress" ref={barRef} />
      <div className="cursor-glow" ref={glowRef} aria-hidden="true" />
    </>
  )
}

export default ScrollEffects
